import React from 'react';
import { createRoot } from 'react-dom/client';
import '@bostonglobe/bgmp-dsm/dist/index.css';
import './index.css';
// global import for symbol ponyfill - Required for React.Fragment usage
import 'es6-symbol';
import Header from './containers/Header/Header';
import Main from './containers/Main';
import Footer from './containers/Footer/Footer';
import registerServiceWorker from './registerServiceWorker';
import Utilities from './utilities';

const rootElement = document.getElementById("root");
const root = createRoot(rootElement);
root.render(
  <div>
    <Header />
    <Main />
    <Footer suppressSubscribeLinks={Utilities.suppressSubscribeLinks} />
  </div>
);
registerServiceWorker();
